import { render, staticRenderFns } from "./EmployeeMessages.vue?vue&type=template&id=b2b5ee8c&scoped=true&"
import script from "./EmployeeMessages.vue?vue&type=script&lang=js&"
export * from "./EmployeeMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b5ee8c",
  null
  
)

export default component.exports